import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
  ModalHeader,
} from "reactstrap";

import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import ShipPage from "../VessalControl/Ship";

const ProductionPlanningAdminPage = () => {
 // const authToken = JSON.parse(localStorage.getItem("authUser")).token;
    const authToken =localStorage.getItem("access");
  const [productionData, setProductionData] = useState([]);
   const shipPath = [
    { lat: 12.9716, lng: 77.5946 },
    { lat: 13.0827, lng: 80.2707 },
    { lat: 15.2993, lng: 74.124 },
  ];
  const fetchEvents = async () => {
    try {
      // Fetch data from your API
      const response = await fetch("http://ec2-35-154-129-107.ap-south-1.compute.amazonaws.com:3003/api/events", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`, // Replace with your actual token
        },
      });

      if (response.ok) {
        const data = await response.json();
        // console.log(data);
        setProductionData(data);
      } else if (response.status === 401) {
        // Unauthorized: Log out the user
        localStorage.removeItem("authUser");
        localStorage.removeItem("admin");
      } else {
        console.error("Error fetching data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  const handleDeleteEvent = async (id) => {
    try {
      // Make API request to delete the user
      const response = await fetch(`http://ec2-35-154-129-107.ap-south-1.compute.amazonaws.com:3003/api/events/${id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${authToken}`, // Replace with your actual token
        },
      });

      if (response.ok) {
        // If the deletion was successful, refresh the user data
        toast.success("Deleted Successfully");
        fetchEvents();
      } else if (response.status === 401) {
        // Unauthorized: Log out the user
        localStorage.removeItem("authUser");
        localStorage.removeItem("admin");
      } else {
        toast.error("Error deleting data:", response.statusText);
      }
    } catch (error) {
      console.error("Error deleting user:", error);
    }
  };

  const [searchTerm, setSearchTerm] = useState("");

  const handleSearchTermChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const filteredCompany = productionData.filter((data) =>
    data.machine.machine_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // pagination
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  // Calculate the total number of pages
  const totalPages = Math.ceil(filteredCompany.length / itemsPerPage);

  // Calculate the index of the first and last item of the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  // Get the items for the current page
  const currentItems = filteredCompany.slice(indexOfFirstItem, indexOfLastItem);

  // Handle Previous button click
  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  // Handle Next button click
  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="OptiMize" breadcrumbItem="Batch Control" />

          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <h4 className="card-title mb-0">
                    View & Delete Production Planning Data.
                  </h4>
                </CardHeader>

                <CardBody>
                  <div id="customerList">
                    <Row className="g-4 mb-3">
                      <Col className="col-sm-auto">
                        <div
                          className="d-flex align-items-center gap-1"
                          style={{ fontSize: "30px", cursor: "pointer" }}
                        >
                          <i className="mdi mdi-microsoft-excel text-success"></i>
                          <span
                            className="text-success"
                            style={{ fontSize: "15px", textAlign: "center" }}
                          >
                            Export Data
                          </span>
                        </div>
                      </Col>
                      <Col className="col-sm">
                        <div className="d-flex justify-content-sm-end">
                          <div className="search-box ms-2">
                            <input
                              type="text"
                              className="form-control search"
                              placeholder="Search..."
                              value={searchTerm}
                              onChange={handleSearchTermChange}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>

                    <div className="table-responsive table-card mt-3 mb-1">
                      <table
                        className="table align-middle table-nowrap"
                        id="customerTable"
                      >
                        <thead className="table-light">
                          <tr>
                            <th className="sort" data-sort="customer_name">
                              Machine Name
                            </th>
                            <th className="sort" data-sort="logo">
                              Part Name
                            </th>
                            <th className="sort" data-sort="logo">
                              Total Parts Required
                            </th>
                            <th className="sort" data-sort="logo">
                              Backlog
                            </th>
                            <th className="sort" data-sort="logo">
                              Cycle Time
                            </th>
                            <th className="sort" data-sort="logo">
                              Max Parts Per Shift
                            </th>
                            <th className="sort" data-sort="logo">
                              Shifts Planned
                            </th>
                            <th className="sort" data-sort="logo">
                              Include Sunday
                            </th>
                            <th className="sort" data-sort="logo">
                              Total Events
                            </th>
                            <th className="sort" data-sort="action">
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody className="list form-check-all">
                          {currentItems === undefined ? (
                            <tr>
                              <td colSpan="4" className="text-center">
                                Loading...
                              </td>
                            </tr>
                          ) : currentItems.length === 0 ? (
                            <tr>
                              <td colSpan="4" className="text-center">
                                No content found
                              </td>
                            </tr>
                          ) : (
                            currentItems.map((data, index) => (
                              <tr key={index}>
                                <td className="customer_name">
                                  {data.machine.machine_name}
                                </td>
                                <td>{data.selectedPart}</td>
                                <td>{data.totalPartsRequired || "NA"}</td>
                                <td>{data.backlog || "NA"}</td>
                                <td>{data.cycleTime || "NA"}</td>
                                <td>{data.maxPartsPerShift || "NA"}</td>
                                <td>
                                  {data.shiftsPlanned
                                    ? Object.entries(data.shiftsPlanned)
                                        .map(
                                          ([shift, isPlanned]) =>
                                            `${shift}: ${
                                              isPlanned ? "Yes" : "No"
                                            }`
                                        )
                                        .join(", ")
                                    : "NA"}
                                </td>
                                <td>{data.includeSunday || "NA"}</td>
                                <td>{data.events.length || "NA"}</td>
                                <td>
                                  <div className="d-flex gap-2">
                                    {/* <div className="edit">
                                      <button
                                        className="btn btn-warning"
                                        onClick={() => {
                                          setmodal_list(true);
                                          setEditCompany(machine);
                                        }}
                                      >
                                        Edit
                                      </button>
                                    </div> */}
                                    <div className="remove">
                                      <button
                                        className="btn btn-danger remove-item-btn"
                                        data-bs-toggle="modal"
                                        data-bs-target="#deleteRecordModal"
                                        onClick={() =>
                                          handleDeleteEvent(data._id)
                                        }
                                      >
                                        Delete
                                      </button>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                      <div className="noresult" style={{ display: "none" }}>
                        <div className="text-center">
                          <lord-icon
                            src="https://cdn.lordicon.com/msoeawqm.json"
                            trigger="loop"
                            colors="primary:#121331,secondary:#08a88a"
                            style={{ width: "75px", height: "75px" }}
                          ></lord-icon>
                          <h5 className="mt-2">Sorry! No Result Found</h5>
                          <p className="text-muted mb-0">
                            We've searched more than 150+ Orders We did not find
                            any orders for you search.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="d-flex justify-content-end">
                      <div className="pagination-wrap hstack gap-2">
                        <Link
                          className={`page-item pagination-prev ${
                            currentPage === 1 ? "disabled" : ""
                          }`}
                          to="#"
                          onClick={handlePrevious}
                        >
                          Previous
                        </Link>
                        <ul className="pagination listjs-pagination mb-0">
                          <li>
                            Page {currentPage} of {totalPages}
                          </li>
                        </ul>
                        <Link
                          className={`page-item pagination-next ${
                            currentPage === totalPages ? "disabled" : ""
                          }`}
                          to="#"
                          onClick={handleNext}
                        >
                          Next
                        </Link>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>



 


   




            </Col>
          </Row>
        </Container>
       {/* <ShipPage/> */}
      </div>
    </React.Fragment>
  );
};

export default ProductionPlanningAdminPage;
